// Juridiske tekster. Punkter markeret med pending: true afventer godkendelse fra Kepp & Co.
import { contact } from './mock';

const updated = 'Juni 2026';

const controller = [
  { t: contact.company },
  { t: `${contact.address}, ${contact.zip}` },
  { t: `CVR: ${contact.cvr}` },
  { t: `E-mail: ${contact.email}` },
  { t: `Tlf.: ${contact.phone}` },
];

export const privacyPolicy = {
  slug: 'privatlivspolitik',
  eyebrow: 'Juridisk',
  title: 'Privatlivspolitik',
  updated,
  sections: [
    {
      h: '1. Dataansvarlig',
      p: ['Den dataansvarlige for behandlingen af dine personoplysninger på denne hjemmeside er:'],
      list: controller,
    },
    {
      h: '2. Hvilke oplysninger vi behandler',
      p: ['Vi behandler kun de personoplysninger, du selv giver os, samt begrænsede tekniske oplysninger, der er nødvendige for at drive hjemmesiden sikkert.'],
      list: [
        { t: 'Kontaktformularen: fornavn, efternavn, e-mailadresse, virksomhed (valgfrit) og indholdet af din besked.' },
        { t: 'Henvendelser og uopfordrede ansøgninger pr. e-mail: de oplysninger, du selv sender, fx navn, kontaktoplysninger, CV og ansøgning.' },
        { t: 'Teknisk: din IP-adresse anvendes midlertidigt til at beskytte kontaktformularen mod spam og misbrug. IP-adressen gemmes ikke sammen med din henvendelse.' },
        { t: 'Statistik: hvis du giver samtykke, indsamles oplysninger om din brug af hjemmesiden via Google Analytics (se afsnit 6 og vores cookiepolitik).' },
      ],
    },
    {
      h: '3. Formål og retsgrundlag',
      list: [
        { t: 'Besvarelse af henvendelser og dialog om projekter og samarbejde. Retsgrundlag: vores legitime interesse i at besvare henvendelser og føre forretningsdialog, jf. databeskyttelsesforordningens art. 6, stk. 1, litra f, samt forberedelse af en eventuel aftale, jf. litra b.' },
        { t: 'Behandling af uopfordrede ansøgninger med henblik på eventuel ansættelse. Retsgrundlag: art. 6, stk. 1, litra b og f.' },
        { t: 'Sikkerhed og forebyggelse af misbrug af kontaktformularen. Retsgrundlag: art. 6, stk. 1, litra f.' },
        { t: 'Statistik om brugen af hjemmesiden. Retsgrundlag: dit samtykke, jf. art. 6, stk. 1, litra a, og cookiebekendtgørelsen. Du kan til enhver tid trække dit samtykke tilbage.' },
      ],
    },
    {
      h: '4. Sådan opbevares henvendelser fra kontaktformularen',
      p: [
        'Når du sender kontaktformularen, overføres oplysningerne krypteret (HTTPS) til vores server. Her gemmes en kopi af henvendelsen i en lukket database, som ikke er tilgængelig via hjemmesiden, og henvendelsen videresendes samtidig pr. e-mail til ' + contact.email + '. Oplysningerne gemmes ikke i din browser.',
      ],
    },
    {
      h: '5. Modtagere og databehandlere',
      p: ['Vi sælger ikke dine oplysninger og videregiver dem ikke til andre formål. Vi benytter følgende leverandører (databehandlere), som behandler oplysninger på vores vegne og efter vores instruks:'],
      list: [
        { t: 'Hosting og database for hjemmesiden og kontaktformularen.', pending: 'Nuværende platform (Emergent) hoster i USA (database: MongoDB Atlas, us-central1). Valg af endelig hosting og databehandleraftale afventer' },
        { t: 'E-mailafsendelse af formularhenvendelser via Resend (Resend, Inc., USA). Overførsel til USA sker på grundlag af EU-U.S. Data Privacy Framework og/eller EU-Kommissionens standardkontraktbestemmelser.', pending: 'Kepp & Co. bør bekræfte databehandleraftale' },
        { t: 'Kepp & Co.s egen e-mailudbyder, hvor henvendelser modtages.', pending: 'Navn på e-mailudbyder (fx Microsoft 365) skal oplyses' },
        { t: 'Google Ireland Ltd. (Google Analytics og Google Tag Manager), kun hvis du har givet samtykke til statistik. Google kan overføre oplysninger til USA under EU-U.S. Data Privacy Framework.' },
      ],
    },
    {
      h: '6. Google Analytics',
      p: [
        'Vi anvender Google Analytics 4 via Google Tag Manager til at forstå, hvordan hjemmesiden bruges. Disse værktøjer aktiveres først, når du har givet samtykke til statistik i vores cookiebanner. Uden samtykke indlæses de ikke. Trækker du samtykket tilbage, slettes Google Analytics-cookies fra din browser.',
        'Google Analytics 4 gemmer ikke fulde IP-adresser. Data opbevares i Google Analytics i højst 14 måneder.',
      ],
      pendingNote: 'Opbevaringsperiode i GA4 (2 eller 14 måneder) skal bekræftes',
    },
    {
      h: '7. Opbevaring og sletning',
      list: [
        { t: 'Kopien af henvendelser fra kontaktformularen, der gemmes på vores server, slettes automatisk 12 måneder efter modtagelsen.' },
        { t: 'Henvendelser i vores e-mail opbevares, så længe det er nødvendigt for dialogen, og slettes senest 12 måneder efter sidste kontakt, medmindre de indgår i et kundeforhold eller en aftale, hvor bogføringsloven kan kræve længere opbevaring.' },
        { t: 'Uopfordrede ansøgninger opbevares i op til 6 måneder og slettes derefter, medmindre du har givet samtykke til længere opbevaring.', pending: '6 måneder er et forslag og skal godkendes' },
      ],
    },
    {
      h: '8. Dine rettigheder',
      p: ['Du har efter databeskyttelsesforordningen ret til:'],
      list: [
        { t: 'at få indsigt i de oplysninger, vi behandler om dig' },
        { t: 'at få urigtige oplysninger rettet' },
        { t: 'at få oplysninger slettet' },
        { t: 'at få behandlingen begrænset' },
        { t: 'at gøre indsigelse mod behandling baseret på legitim interesse' },
        { t: 'at modtage dine oplysninger i et struktureret format (dataportabilitet)' },
        { t: 'at trække et samtykke tilbage, uden at det påvirker lovligheden af behandlingen før tilbagetrækningen' },
      ],
      after: [`Kontakt os på ${contact.email}, hvis du vil gøre brug af dine rettigheder.`],
    },
    {
      h: '9. Klage',
      p: ['Du kan klage over vores behandling af dine personoplysninger til Datatilsynet, Carl Jacobsens Vej 35, 2500 Valby, www.datatilsynet.dk.'],
    },
    {
      h: '10. Ændringer',
      p: ['Vi kan opdatere denne privatlivspolitik, hvis hjemmesidens funktioner eller lovgivningen ændres. Den seneste version findes altid på denne side.'],
    },
  ],
};

export const cookiePolicy = {
  slug: 'cookiepolitik',
  eyebrow: 'Juridisk',
  title: 'Cookiepolitik',
  updated,
  sections: [
    {
      h: '1. Hvad er cookies?',
      p: ['Cookies er små tekstfiler, der gemmes på din computer, tablet eller telefon, når du besøger en hjemmeside. Tilsvarende teknologier, fx lokal lagring i browseren (localStorage), behandles på samme måde som cookies i denne politik.'],
    },
    {
      h: '2. Hvem står bag hjemmesiden?',
      list: controller,
    },
    {
      h: '3. Nødvendige cookies',
      p: ['Disse er nødvendige for, at hjemmesiden fungerer, og kræver ikke samtykke.'],
      table: [
        ['kepp_consent', 'Kepp & Co.', 'Husker dit cookievalg', '12 måneder', 'Lokal lagring'],
      ],
    },
    {
      h: '4. Statistikcookies (kræver samtykke)',
      p: ['Hvis du accepterer statistik, anvender vi Google Analytics 4 via Google Tag Manager til at måle, hvordan hjemmesiden bruges. Uden samtykke indlæses Google Tag Manager og Google Analytics ikke, og der sættes ingen statistikcookies.'],
      table: [
        ['_ga', 'Google', 'Adskiller besøgende statistisk', '2 år', 'HTTP-cookie'],
        ['_ga_JE2XN19KNF', 'Google', 'Gemmer sessionsstatus for statistik', '2 år', 'HTTP-cookie'],
      ],
    },
    {
      h: '5. Marketingcookies (kræver samtykke)',
      p: ['Vi anvender i dag ingen marketingcookies. Kategorien findes i cookiebanneret, så vi kan bede om samtykke, hvis vi senere tager fx annoncemåling i brug. Denne politik opdateres i så fald.'],
    },
    {
      h: '6. Samtykke og Google Consent Mode',
      p: [
        'Statistik- og marketingværktøjer indlæses først, når du har givet samtykke. Vi anvender Google Consent Mode v2, hvor alle Google-tjenester som udgangspunkt er sat til “afvist”, indtil du aktivt vælger andet.',
        'Dit samtykke gælder i 12 måneder. Derefter bliver du spurgt igen.',
        'Du kan til enhver tid ændre eller trække dit samtykke tilbage via “Cookieindstillinger” nederst på siden eller via knappen herunder. Når du trækker samtykket til statistik tilbage, slettes Google Analytics-cookies fra din browser.',
      ],
      settingsButton: true,
    },
    {
      h: '7. Indhold fra tredjeparter',
      p: ['Skrifttyper og billeder hostes på vores egen server. Hjemmesiden opretter derfor ikke forbindelse til tredjeparter, før du har givet samtykke til statistik eller marketing.'],
    },
    {
      h: '8. Sådan sletter du cookies',
      p: ['Du kan slette cookies og lokal lagring i din browsers indstillinger. Bemærk, at cookiebanneret vises igen, hvis du sletter dit cookievalg.'],
    },
    {
      h: '9. Mere information',
      p: ['Læs mere om, hvordan vi behandler personoplysninger, i vores privatlivspolitik. Har du spørgsmål, er du velkommen til at kontakte os på ' + contact.email + '.'],
    },
  ],
};
